export const CHECKMARK_ICON = '/assets/images/checkmark.svg';
